import { CancelEmailChangeResult, TCancelEmailChange } from '@onesource/schemas';
import { useMutation } from '@tanstack/react-query';

import axios from '../../common/axios';
import { ENTITY } from './entity';

/**
 * Cancels a pending email change using the cancel token from the old-address
 * security email. Public endpoint — also force-triggers a password reset on the
 * old address to secure the account.
 */
export const useCancelEmailChangeMutation = () => {
  return useMutation<CancelEmailChangeResult, Error, TCancelEmailChange>({
    mutationFn: async (payload: TCancelEmailChange) => {
      const { data } = await axios.post<CancelEmailChangeResult>(`${ENTITY}/email-change/cancel`, payload);
      return data;
    },
  });
};
